$(document).ready(function () {
    function initializeSlider($slider) {
        if (!$slider.length) return;
        const $entertainmentBlock = $slider.closest('.entertainment');
        const $arrowsContainer = $entertainmentBlock.find('.entertainment__nav');

        $slider.slick({
            slidesToShow: 4,
            appendArrows: $arrowsContainer,
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: { slidesToShow: 3 }
                },
                {
                    breakpoint: 736,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true
                    }
                },
            ]
        });
    }

    $('.entertainment__slider.entertainment__slider--slides-show-four').each(function () {
        initializeSlider($(this));
    });
});
